import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './LinkToolbar.css';

const links = [
  { url: 'https://www.ceara.gov.br/', key: 'portalGov' },
  { url: 'https://cearatransparente.ce.gov.br/', key: 'cearaTransparente' },
  {
    url: 'https://cearatransparente.ce.gov.br/portal-da-transparencia/ouvidoria?locale=pt-BR',
    key: 'ouvidoria'
  },
  {
    url: 'https://cearatransparente.ce.gov.br/portal-da-transparencia/acesso-a-informacao?locale=pt-BR',
    key: 'acessoInfo'
  },
    {
    url: 'https://pedea.sema.ce.gov.br/gestor/',
    key: 'acessoGestor'
  }
];

const LinkToolbar = () => {
  const { t } = useTranslation();
  const menuRef = useRef(null);

  const toggleMenu = () => {
    const el = menuRef.current;
    const isHidden = !el || el.style.visibility === '' || el.style.visibility === 'hidden';

    el.style.visibility = isHidden ? 'visible' : 'hidden';
    el.style.opacity = isHidden ? '1' : '0';
    el.style.zIndex = isHidden ? '4' : '0';
  };

  return (
    <div className="LinkToolbar">
      <a onClick={toggleMenu} className="LinkToolbarToggler" href="#!">
        ☰
      </a>

     
      <div ref={menuRef} className="LinkToolbarDropdown">
        {links.map(({ url, key }) => (
          <div key={key}>
            <a href={url} target="_blank" rel="noreferrer">
              {t(key)}
            </a>
          </div>
        ))}
      </div>

    
      {links.map(({ url, key }) => (
        <a key={key} className="LinkToolbarLink" href={url} target="_blank" rel="noreferrer">
          {t(key)}
        </a>
      ))}
    </div>
  );
};

export default LinkToolbar;
